import { createSelectOptionsFromSysEnums } from '../../../shared/form-elements/select';

import { enum as payoutStatuses } from '../../../../../../../enums/payout-statuses';

const defaultInitialState = {
	fields: {
		statuses: null
	}
};

const createForm = ({ namespace, stateNodeName }) => {
	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {};

	// reducers
	const reducers = {};

	// selectors
	const selectors = {
		getFormData: state => {
			const { filtersForm: { fields }, selectedFilters } = state.payoutsList;

			const statusSelectOptions = createSelectOptionsFromSysEnums(state.root.lists['payout-statuses'])
				.filter((option) => option.value !== payoutStatuses.partially); // status for affiliate cabinet

			return {
				selectOptions: {
					statuses: statusSelectOptions
				},
				initialValues: {
					...fields,
					statuses:
						selectedFilters.statuses ||
							(statusSelectOptions &&
								statusSelectOptions.filter(status => status.value === 'approved' || status.value === 'pending'))
				}
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/filters/index.js